import React from "react";

const AdminFooterComponent = () => {
  return <div>Admin Fotter</div>;
};

export default AdminFooterComponent;
